import request, { uploadFile } from "../utils/request";

export async function getLoginInfo(params) {
  const res = await request({
    url: "/sys_user/login",
    method: "get",
    params: params,
  });

  return res;
}
